import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="237.98854" cy="316.28793" />
				<g className="fill--eyes eyes">
					<ellipse transform="matrix(0.92835 -0.3717 0.3717 0.92835 -98.37289 122.22813)" cx="267.86676" cy="316.28809" rx="7.27204" ry="8.08004" />
					<ellipse transform="matrix(0.3717 -0.92835 0.92835 0.3717 -162.97733 391.7662)" cx="207.94176" cy="316.28809" rx="8.08004" ry="7.27204" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M215.76994,320.33267c-0.15819,0-0.31837-0.0145-0.47957-0.04504l-15.65034-2.96246
						c-1.39062-0.26331-2.3047-1.6044-2.0414-2.99503c0.26331-1.39111,1.60287-2.30371,2.99451-2.0419l15.65036,2.96249
						c1.39062,0.26331,2.3047,1.60437,2.0414,2.995C218.05263,319.47568,216.97736,320.33267,215.76994,320.33267z" />
					<path d="M260.03857,320.33267c0.1582,0,0.31839-0.0145,0.47958-0.04504l15.65036-2.96246
						c1.39062-0.26331,2.30469-1.6044,2.04138-2.99503c-0.26331-1.39111-1.60287-2.30371-2.99451-2.0419l-15.65036,2.96249
						c-1.39062,0.26331-2.30469,1.60437-2.04138,2.995C257.75592,319.47568,258.83118,320.33267,260.03857,320.33267z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M215.52158,320.19641c-0.61974,0-1.24046-0.22327-1.73303-0.67578c-0.94211-0.86502-2.9765-1.84366-5.86188-1.99533
						c-2.88338-0.14618-5.01088,0.60919-6.03809,1.37161c-1.13834,0.84448-2.74222,0.60568-3.58521-0.53012
						c-0.84398-1.13635-0.6067-2.74173,0.52963-3.58572c2.29068-1.70099,5.69066-2.56851,9.36197-2.37479
						c3.65829,0.19223,6.96117,1.40967,9.06163,3.33994c1.04222,0.95761,1.1113,2.57901,0.15318,3.62125
						C216.90419,319.9176,216.21439,320.19641,215.52158,320.19641z" />
					<path d="M260.28696,320.19641c0.61972,0,1.24045-0.22327,1.73303-0.67578c0.94211-0.86502,2.9765-1.84366,5.86188-1.99533
						c2.88339-0.14618,5.01086,0.60919,6.03809,1.37161c1.13834,0.84448,2.74222,0.60568,3.58521-0.53012
						c0.84399-1.13635,0.60672-2.74173-0.52963-3.58572c-2.29068-1.70099-5.69067-2.56851-9.36197-2.37479
						c-3.65829,0.19223-6.96115,1.40967-9.06161,3.33994c-1.04224,0.95761-1.11133,2.57901-0.1532,3.62125
						C258.90433,319.9176,259.59415,320.19641,260.28696,320.19641z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M261.11575,318.99112c1.65872,4.14273,6.02591,6.29092,9.75439,4.79807c3.72849-1.49283,5.40884-6.06238,3.74762-10.20413
						c-0.93921-2.34167-5.1908-1.94971-9.72952-0.901C261.39789,313.49054,259.45703,314.84836,261.11575,318.99112z" />
					<path d="M214.69385,318.99112c-1.65872,4.14273-6.02591,6.29092-9.75439,4.79807
						c-3.72847-1.49283-5.40884-6.06238-3.74763-10.20413c0.93921-2.34167,5.1908-1.94971,9.72954-0.901
						C214.41173,313.49054,216.35255,314.84836,214.69385,318.99112z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Seal/Eyes.js